<template>
  <ShieldCheckIcon class="text-brand-green w-12 h-12 mx-auto my-5" />
  <h2 class="text-xl font-semibold py-5 text-center">Success!</h2>
  <p v-if="context === 'applicant'" class="py-3 text-center">Your identity has been verified</p>
  <p v-else class="py-3 text-center">
    Experian credit reports have been automatically added to forms you've created
  </p>
  <div class="flex mx-auto md:w-1/3 py-5">
    <PrimaryButton @click="navigate">{{
      context === "applicant" ? "Next" : "Return to dashboard"
    }}</PrimaryButton>
  </div>
</template>
<script>
import { ShieldCheckIcon } from "@heroicons/vue/outline"
import { USER_GET } from "@/store/types"

import { mapGetters } from "vuex"

export default {
  components: {
    ShieldCheckIcon
  },
  computed: {
    ...mapGetters(["getCurrentApplication"])
  },
  props: {
    context: {
      type: String,
      default: "landlord"
    }
  },
  methods: {
    async navigate() {
      if (this.context === "applicant") {
        if (this.getCurrentApplication.need_applicant_finicity_bank_connection) {
          this.$router.push({
            name: "apply_verify_income",
            params: { id: this.$route.params.id }
          })
        } else {
          if (this.getCurrentApplication.is_paid) {
            // if (!this.getCurrentApplication.applicant.affiliate_offer_optin) {
            //   this.$router.push({
            //     name: "apply_affiliate_optin",
            //     params: { id: this.getCurrentApplication.id }
            //   })
            // } else {
            //   this.$router.push({
            //     name: "apply_complete",
            //     params: { id: this.$route.params.id }
            //   })
            // }

            this.$router.push({
              name: "apply_complete",
              params: { id: this.$route.params.id }
            })
          } else {
            this.$router.push({
              name: "apply_pay",
              params: { id: this.$route.params.id }
            })
          }
        }
      } else {
        //reload user for rsp warning
        const redirectAppId = localStorage.getItem('redirect_after_verify')
        try {
          await this.$store.dispatch(USER_GET)

          if (redirectAppId) {
            localStorage.removeItem('redirect_after_verify')
            this.$router.push({ 
              name: "dashboard_view_application_report", 
              params: { id: redirectAppId, type: 'credit' } 
            })
          } else {
            this.$router.push({ name: "dashboard_forms" })

          }
          
        } catch (err) {
          console.log(err)
        }
      }
    }
  }
}
</script>
